<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}-1">
						<h4 class="card-title"><i class="material-icons" (click)="back()">arrow_left</i> Move Transactions Between Customers</h4>
						<p class="card-category text-right">Move transactions between customers. Allocations are not removed.</p>
					</div>
					<div class="card-body">
						<div class="row">
							<div class="col-md-6">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>From customer</mat-label>
									<input type="text" matInput [formControl]="fromcustomer" (input)="customerSearch($any($event.target).value, 'from')" [matAutocomplete]="autoFrom" />
									<mat-autocomplete #autoFrom="matAutocomplete" [displayWith]="displayFn" (optionSelected)="setFrom($event.option.value)">
										<mat-option *ngFor="let option of fromresults" [value]="option">{{ option.debtorno }} {{ option.name }}</mat-option>
									</mat-autocomplete>
								</mat-form-field>
							</div>
							<div class="col-md-6">
								<mat-form-field appearance="outline" class="w-100">
									<mat-label>To customer</mat-label>
									<input type="text" matInput [formControl]="tocustomer" (input)="customerSearch($any($event.target).value, 'to')" [matAutocomplete]="autoTo" />
									<mat-autocomplete #autoTo="matAutocomplete" [displayWith]="displayFn" (optionSelected)="setTo($event.option.value)">
										<mat-option *ngFor="let option of toresults" [value]="option"><b>{{ option.debtorno }}:</b> {{ option.name }}</mat-option>
									</mat-autocomplete>
								</mat-form-field>
							</div>
						</div>

						<ng-container *ngIf="!transactions">
							<p class="text-muted">Select a "From" customer to load their transactions, then choose a "To" customer and select which transactions to move.</p>
						</ng-container>

						<ng-container *ngIf="transactions">
							<div class="row align-items-center mb-2">
								<div class="col-auto">
									<mat-form-field appearance="outline" class="filter-field">
										<mat-label>Filter</mat-label>
										<input matInput [formControl]="filterControl" placeholder="Order #, doc #, amount, type…" />
									</mat-form-field>
								</div>
								<div class="col-auto">
									<mat-form-field appearance="outline" class="type-filter-field">
										<mat-label>Type</mat-label>
										<mat-select [formControl]="typeFilterControl" multiple placeholder="All">
											<mat-option *ngFor="let t of typeFilters" [value]="t.value">{{ t.name }}</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="col text-end" *ngIf="from && to">
									<button mat-raised-button color="accent" (click)="moveTransactions()" [disabled]="selected.length === 0">
										<i class="fa fa-send"></i> Move {{ selected.length ? selected.length : '' }} transaction(s)
									</button>
								</div>
							</div>
							<div *ngIf="from && to && selected.length === 0" class="alert alert-info">Select rows below to move.</div>

							<div class="table-responsive mat-elevation-z2">
								<table mat-table [dataSource]="dataSource" matSort class="move-trans-table">
									<ng-container matColumnDef="select">
										<th mat-header-cell *matHeaderCellDef>
											<mat-checkbox (change)="checkAll($event)" [checked]="isAllChecked()" [indeterminate]="selected.length > 0 && !isAllChecked()"></mat-checkbox>
										</th>
										<td mat-cell *matCellDef="let t">
											<mat-checkbox [checked]="isSelected(t)" (change)="toggleSelection(t)"></mat-checkbox>
										</td>
									</ng-container>
									<ng-container matColumnDef="transno">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Doc #</th>
										<td mat-cell *matCellDef="let t">{{ t.transno }}</td>
									</ng-container>
									<ng-container matColumnDef="typename">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
										<td mat-cell *matCellDef="let t">{{ t.typename }}</td>
									</ng-container>
									<ng-container matColumnDef="trandate">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
										<td mat-cell *matCellDef="let t">{{ t.trandate }}</td>
									</ng-container>
									<ng-container matColumnDef="duedate">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Due</th>
										<td mat-cell *matCellDef="let t">{{ t.duedate || '—' }}</td>
									</ng-container>
									<ng-container matColumnDef="order_">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Order #</th>
										<td mat-cell *matCellDef="let t">{{ t.order_ ?? '—' }}</td>
									</ng-container>
									<ng-container matColumnDef="invtext">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Reference</th>
										<td mat-cell *matCellDef="let t">{{ t.invtext || '—' }}</td>
									</ng-container>
									<ng-container matColumnDef="enteredby">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Entered by</th>
										<td mat-cell *matCellDef="let t">{{ t.enteredby || '—' }}</td>
									</ng-container>
									<ng-container matColumnDef="settled">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Settled</th>
										<td mat-cell *matCellDef="let t">{{ t.settled ?? '—' }}</td>
									</ng-container>
									<ng-container matColumnDef="totalamount">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
										<td mat-cell *matCellDef="let t">{{ t.totalamount | currency }}</td>
									</ng-container>
									<ng-container matColumnDef="allocated">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Applied</th>
										<td mat-cell *matCellDef="let t">{{ t.allocated != null ? (t.allocated | currency) : '—' }}</td>
									</ng-container>
									<ng-container matColumnDef="balance">
										<th mat-header-cell *matHeaderCellDef mat-sort-header>Balance</th>
										<td mat-cell *matCellDef="let t">{{ t.balance != null ? (t.balance | currency) : '—' }}</td>
									</ng-container>

									<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
									<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
									<tr class="mat-row" *matNoDataRow>
										<td class="mat-cell" [attr.colspan]="displayedColumns.length">No transactions match the filters.</td>
									</tr>
								</table>
							</div>
							<mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
